import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { IWarehouse } from 'modules/inventory/warehouse/interfaces';
import { PRODUCT_OFFER_METRIC_ENUM } from '../constants/metrics/sales.offer-metric';

class AnalyticProductOfferService extends EntityApiService<IWarehouse> {
  request = (
    offerId: string,
    metric: PRODUCT_OFFER_METRIC_ENUM,
    params?: any,
    config?: RequestConfig,
  ): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${offerId}/${metric}`), params, config));
  };
}

export default new AnalyticProductOfferService('/ms-analytics/api/v1/product-offers');
